import Swal from 'sweetalert2';

type AlertType = 'success' | 'error' | 'warning' | 'info';

export const showAlert = (
  type: AlertType,
  title: string,
  message: string
): void => {
  const config = {
    title,
    text: message,
    icon: type,
    confirmButtonText: 'OK',
    confirmButtonColor: getButtonColor(type),
  };

  Swal.fire(config);
};

const getButtonColor = (type: AlertType): string => {
  const colors = {
    success: '#28a745',
    error: '#dc3545',
    warning: '#ffc107',
    info: '#17a2b8',
  };
  return colors[type];
};

export const showSuccess = (title: string, message: string): void => {
  showAlert('success', title, message);
};

export const showError = (title: string, message: string): void => {
  showAlert('error', title, message);
};

export const showWarning = (title: string, message: string): void => {
  showAlert('warning', title, message);
};

export const showInfo = (title: string, message: string): void => {
  showAlert('info', title, message);
};